class MgmContentProtection {
  constructor() {
    this.onContextMenu = this.onContextMenu.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
  }

  init() {
    document.addEventListener('contextmenu', this.onContextMenu);
    document.addEventListener('mousedown', this.onMouseDown, true);
  }

  onContextMenu(event) {
    if (this.isEditable(event.target)) return;
    event.preventDefault();
  }

  onMouseDown(event) {
    if (event.button !== 2 || this.isEditable(event.target)) return;
    event.preventDefault();
  }

  isEditable(target) {
    return target instanceof Element && Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
  }
}

new MgmContentProtection().init();
